import gql from 'graphql-tag'

import selectableChannelFragment from 'v2/components/ConnectionSelectionList/components/SelectableChannel/fragments/selectableChannel'

export default gql`
  query SearchedChannelsQuery($query: String!) {
    me {
      __typename
      id
      searched_channels: connection_search(q: $query, per: 5) {
        ...SelectableChannel
      }
    }
  }
  ${selectableChannelFragment}
`
